// extracted by mini-css-extract-plugin
export var aboutFloorball = "floorball-module--about-floorball--d6AIR";
export var floorballContent = "floorball-module--floorball-content--61gsF";
export var floorballFlexContainer = "floorball-module--floorball-flex-container--bbZni";
export var floorballSection = "floorball-module--floorball-section--M3gM7";
export var floorballWrapper = "floorball-module--floorball-wrapper--2Oe36";
export var img = "floorball-module--img--dAdjS";
export var imgContainer = "floorball-module--img-container--RDZMP";